//! @ngInject
export function patientTaskAssignMultipleModal($scope, $uibModalInstance) {
    // The picker narrows by certification on the server; nothing is held here.
    $scope.allowedCertifications = $scope.allowedCertifications;
    $scope.caregiverId = null;

    $scope.handleCaregiverSelection = (caregiver) => {
        $scope.caregiverId = caregiver.id;
    };

    $scope.handleCaregiverDeselect = () => {
        $scope.caregiverId = null;
    }

    $scope.closeModal = function () {
        $uibModalInstance.dismiss();
    };

    $scope.assignCaregiver = () => {
        if (!$scope.caregiverId) {
            return;
        }
        $uibModalInstance.close($scope.caregiverId);
    }
};